export default __webpack_public_path__ + "static/media/tracking.c7943b42.png";